import { render } from "./vector_1.0.0.vue?vue&type=template&id=1a15ac2e"
import script from "./vector_1.0.0.vue?vue&type=script&lang=ts"
export * from "./vector_1.0.0.vue?vue&type=script&lang=ts"
script.render = render

export default script